import React from "react";
import classNames from "classnames";

import InsightsSmall from "~assets/images/icons/JSX/InsightsSmall";

import classes from "./styles.module.scss";

const InsightsTag = ({ isInsightsActive, className, onClick, disabled = false }) => (
    <div
        className={classNames(classes.insightsTagContainer, {
            [classes.locked]: !isInsightsActive,
            [classes.clickable]: onClick,
            [classes.disabled]: disabled,
            [className]: className,
        })}
        data-tip={isInsightsActive ? "Insights activated" : "Insights locked"}
        data-for="insightsTagTip"
        onClick={disabled ? undefined : onClick}
    >
        <InsightsSmall fill={isInsightsActive ? "#0049C6" : "#c61717"} />
    </div>
);

export default InsightsTag;
